export const reservationsMainQueryKey = "reservations";
